// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1PbH9","title":"Info_title__7JRFy","links":"Info_links__1Pat4","link":"Info_link__2ZX_n","logo":"Info_logo__2RCuf"};